var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeopleB24 = function SvgPeopleB24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.507 7.343a4.343 4.343 0 1 1 8.687 0 4.343 4.343 0 0 1-8.687 0ZM8.85 5a2.343 2.343 0 1 0 0 4.687A2.343 2.343 0 0 0 8.85 5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.355 10.978a3.473 3.473 0 0 1-1.94-.589 6.315 6.315 0 0 0 .779-3.046 6.317 6.317 0 0 0-.664-2.828 3.489 3.489 0 1 1 1.825 6.463ZM14.123 13.117a7.559 7.559 0 0 1 3.533 5.594h2.522c.847 0 1.533-.686 1.533-1.533a4.2 4.2 0 0 0-4.2-4.2H15.2c-.372 0-.733.048-1.077.14Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.143 13A6.143 6.143 0 0 0 2 19.143C2 20.169 2.831 21 3.857 21h10.286A1.857 1.857 0 0 0 16 19.143 6.143 6.143 0 0 0 9.857 13H8.143Zm5.855 6H4.002c.076-2.222 1.9-4 4.14-4h1.715a4.143 4.143 0 0 1 4.14 4Z",
    fill: "currentColor"
  })));
};
export default SvgPeopleB24;